module.exports = __webpack_public_path__ + "media/country_flags/gw-0076faa5.png";